import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SafeUrlPipe } from './safe-url.pipe';
import { AsapClientPipe } from './asap-client.pipe';
import { StreamPipe } from './stream.pipe';
import { ImagePipe } from './image.pipe';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [
    SafeUrlPipe,
    AsapClientPipe,
    StreamPipe,
    ImagePipe
  ],
  exports: [
    SafeUrlPipe,
    AsapClientPipe,
    StreamPipe,
    ImagePipe
  ]
})

export class PipesModule { }



// WEBPACK FOOTER //
// ./src/app/@core/pipes/pipe.module.ts